import type { AggregationResult } from "@/hooks/useAggregations";
import type { AggregationKind } from "@/hooks/table/types";
import AggregationPill from "./aggregation-pill";

interface AggregationsBarProps {
  results: AggregationResult[];
  onSwitchKind?: (key: string, kind: AggregationKind) => void;
  onRemove?: (key: string) => void;
  className?: string;
}

/**
 * Franja de pills que muestra las agregaciones activas. Se usa en la vista
 * mobile (cards) donde no hay alineación por columna. En desktop se usa
 * `AggregationPill` directamente dentro de cada `<td>` del `<tfoot>`.
 */
export default function AggregationsBar({
  results,
  onSwitchKind,
  onRemove,
  className = "",
}: AggregationsBarProps) {
  if (results.length === 0) return null;

  return (
    <div
      className={`flex flex-wrap items-center gap-2 px-4 py-2 border-b border-border bg-card ${className}`}
      data-testid="aggregations-bar"
    >
      {results.map((r) => (
        <AggregationPill
          key={r.key}
          result={r}
          onSwitchKind={onSwitchKind}
          onRemove={onRemove}
        />
      ))}
    </div>
  );
}
